<script setup lang="ts">
import type { TocItem } from './TableOfContentsItem.vue'

const props = defineProps<{
  page: string
  depth?: number
}>()

const store = useStore()
const node = computed<TocItem | null>(() => {
  const page = store.resolvedInlinePages[props.page]

  if (!page) return null
  return {
    id: page.id,
    text: page.title,
    depth: props.depth || page.depth,
    inline: props.page,
  }
})
</script>

<template>
  <ClientOnly>
    <TableOfContentsItem v-if="node && node.depth <= 5" :key="node.id" :node="node" />
  </ClientOnly>
</template>

<style lang="postcss"></style>
